/**
 * Return to top of page via sticky button
 */
( function ( window, document ) {
	let returnBtn = document.getElementById("ncst-return-to-top-btn");

	if( returnBtn != null ) {
	  window.onscroll = function() {scrollFunction()};
	}

  function scrollFunction() {
		let buttonPlacementHeight = screen.height * 1.5;
    if (document.body.scrollTop > buttonPlacementHeight || document.documentElement.scrollTop > buttonPlacementHeight) {
      returnBtn.classList.add('visibleWithFadeIn');
			returnBtn.classList.remove('hiddenWithFadeOut');
    } else {
			returnBtn.classList.remove('visibleWithFadeIn');
			returnBtn.classList.add('hiddenWithFadeOut');
    }
  }

  function topFunction() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }
} )( window, document );
